import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능:클로디공지 리스트
 * 세부설명:
*/

export class ClodMsg extends Component {
    static displayName = ClodMsg.name;

    constructor(props) {
        super(props);
        this.state = {
            TotalCount: 0,
            StartPage: 1,
            EndPage: 10,
            NoticeList: []
        };
        this.handleLink_Click = this.handleLink_Click.bind(this);
        this.handleAdd_Click = this.handleAdd_Click.bind(this);
        this.handleDtl_Click = this.handleDtl_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //초기화
    componentDidMount() {
        
        this.CallClodMsgData(1, 10);
    }
    async CallClodMsgData(StartPage, EndPage) {
        try {

            Big3Common.Util.LoadingOn();
            let Paging = { startpage: StartPage, endpage: EndPage }
            let Data = await Big3Common.Post('api/MyPage/Notice/GetNoticeMgtForClod', {
                Paging: Paging,
                uid_type: this.Uid_Type
            });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let CallList = JSON.parse(Data.multiDataTable);
                let TotalCount = CallList.TotalCount;
                let NowNoticeList = this.state.NoticeList;
                CallList.DataList.map(list => NowNoticeList.push(list));
                this.setState({ NoticeList: NowNoticeList, TotalCount: TotalCount });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallClodMsgData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handleLink_Click(event) {
        this.props.RenderComponent("AlertMsg");
        event.preventDefault();
    }
    handleAdd_Click() {
        let StartPage = this.state.StartPage + 10;
        let EndPage = this.state.EndPage + 10;
        this.setState({ StartPage: StartPage, EndPage: EndPage });
        this.CallClodMsgData(StartPage, EndPage);
    }
    handleDtl_Click(event, noti_idx, notino, wuid) {

        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["NoticeList"]);
        StateCopy.Noti_Idx = noti_idx;
        StateCopy.Notino = notino;
        StateCopy.WUid = wuid;
        this.props.RenderComponent("ClodMsgDtl", StateCopy);
        event.preventDefault();
    }

    render() {
        let NoticeList = this.state.NoticeList;
        return (
            <div >
                <div className="tap_box">
                    <div className="n_tap"><div className="alert_tap" onClick={() => { this.props.RenderComponent('AlertMsg') }} >거래처</div></div>
                    <div className="n_tap"><div className="alert_tap tap_on" >Clo:D공지</div></div>
                </div>

                <div className="container_box a_margin d_padding ">
                    {NoticeList.map(list =>

                        <div className="notice_content pointer"
                            key={list.noti_idx + '_' + list.notino.toString() + '_' + list.wuid}
                            onClick={(e) => this.handleDtl_Click(e, list.noti_idx, list.notino, list.wuid)}
                        >
                            <div className="notice_title">{list.noti_title}</div>
                            <div className="notice_txt">{list.noti_contt}</div>
                            <div className="alert_time">{list.reg_dt}
                                {list.conf_yn === "Y" ? "" : <div className="alert_new"></div>}
                            </div>
                        </div>
                    )}
                </div>           
              
                <div className="more_button">
                    {
                        this.state.TotalCount > this.state.NoticeList.length ?
                            <button type="button" className="btn_v btn_inactive" onClick={this.handleAdd_Click}>더보기</button>
                            : ""
                    }
                </div>

            </div> 
        );
    }
}
